import React from "react";

const socialLinks = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/omovacarbonfiber/",
    icon: "/icons/IG.webp",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/omovacarbonfiber",
    icon: "/icons/Facebook.webp",
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@omovacarbonfiber",
    icon: "/icons/Tiktok.webp",
  },
];

const SocialBar = () => {
  return (
    <div className="flex flex-col items-center w-full mt-12 mb-12">
      {/* Green separator line */}
      <div className="w-full h-[2px] bg-primary-green mb-4" />

      {/* Icons */}
      <div className="flex items-center justify-center gap-6">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img
              src={social.icon}
              alt={social.name}
              className="w-10 h-10 md:w-12 md:h-12"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialBar;
